import React, { useEffect, useState } from 'react';
import { NotificationManager } from '../../../ui/toast';
import { Link } from 'react-router-dom';
import { Button } from '../../../ui';
import { TextInput } from '../../../ui/input/text_input/text_input';
import {
  PrimaryTypography,
  SecondaryTypography,
} from '../../../ui/typography/typography';
import LoadingSpinner from '../../job_openings/create/ui/LoaderSpinner';
import {
  getAnalyticsSettings,
  updateAnalyticsSettings,
} from '../../../utils/api_service/organization_analytics_settings';

export const AnalyticsSettings = () => {
  const [hourlyRate, setHourlyRate] = useState<string>('');
  const [currency, setCurrency] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  const handleSaveButton = () => {
    if (hourlyRate && currency) {
      updateAnalyticsSettings(hourlyRate, currency)
        .then(() => {
          NotificationManager.success('Settings saved successfully!');
        })
        .catch(() => {
          NotificationManager.error('Unable to save settings!');
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    getAnalyticsSettings()
      .then((response) => {
        if (response?.hourlyRate) {
          setHourlyRate(response.hourlyRate);
        }
        if (response?.currency) {
          setCurrency(response.currency);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className='w-full h-full flex flex-col gap-5'>
      <nav
          className='flex w-full justify-between items-center border-b py-3 text-sm'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center space-x-1 md:space-x-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              Admin
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link
                to={'#'}
                className='text-primary-dark font-semibold hover:underline'
            >
              Analytics Settings
            </Link>
          </li>{ ' ' }
          <li>
            <span className='text-gray-400'>/</span>
          </li>
        </ol>
      </nav>

      { loading ? (
        <div className='flex flex-col justify-center items-center min-h-[350px] gap-3 bg-white rounded-xl border border-gray-100 p-8 shadow-sm'>
          <LoadingSpinner label='' />
          <p className='text-xs font-semibold text-slate-400 tracking-wide uppercase'>
            Loading Analytics Settings...
          </p>
        </div>
      ) : (
        <>
          <p>You can change the hourly rate and currency in below.</p>
          <div className='flex flex-col min-h-[80vh] p-4 m-2'>
            <div className='flex items-center mb-4'>
              <SecondaryTypography.Small
                  keepDefaultMargins={true}
                  className='w-1/2 sm:w-1/5'
              >
                Hourly Rate
              </SecondaryTypography.Small>
              <TextInput
                  name='hourlyRate'
                  value={hourlyRate || ''}
                  type='number'
                  onChange={(event) => setHourlyRate(event.target.value)}
              />
            </div>
            <div className='flex items-center mb-4'>
              <SecondaryTypography.Small
                  keepDefaultMargins={true}
                  className='w-1/2 sm:w-1/5'
              >
                Currency
              </SecondaryTypography.Small>
              <TextInput
                  name='currency'
                  value={currency}
                  type='text'
                  onChange={(event) => setCurrency(event.target.value)}
              />
            </div>
            <div className='flex'>
              <Button
                  label='Save'
                  onClick={() => handleSaveButton()}
                  variant='primary'
              />
            </div>
          </div>
        </>
      ) }
    </div>
  );
};
